<template>
  <v-btn id='corpolate-checkout' class="v-btn theme--light btn-big" @click="disableButton(); redirectToStripe()">登録する</v-btn>
</template>

<script>
  import { loadStripe } from '@stripe/stripe-js'
  import axios from 'axios'

  export default {
    props: [
      'stripeKey',
      'stripeProductId',
      'paymentMethodInput',
      'userId'
    ],

    data () {
      return {
        productId: this.stripeProductId,
        stripe: loadStripe(this.stripeKey),
        paymentMethod: this.paymentMethodInput,
        userId: this.userId
      }
    },

    methods: {
      disableButton () {
        document.getElementById('corpolate-checkout').disabled = true
      },

      redirectToStripe: async function () {
        // 銀行振り込みの場合通常の登録確認画面へ
        if (this.paymentMethod == 2) {
          document.getElementById('corporate-plan-form').action = '/register/corporate_plan/bank-confirm'
          document.getElementById('corporate-plan-form').method = 'post'
          document.getElementById('corporate-plan-form').submit()
          return
        }

        const res = await axios.get('/api/create-corporate-checkout-session', {
          params: {
            priceId: this.productId,
            userId: this.userId
          }
        }).then(async res => {
          const data = res.data

          if (res.status !== 200 || !data || data.error) {
            document.getElementById('corpolate-checkout').disabled = false
            return false
          }

          const stripe = await loadStripe(this.stripeKey)

          stripe.redirectToCheckout({
            sessionId: data.sessionId
          })

        }).catch(res => {
          document.getElementById('corpolate-checkout').disabled = false
          console.log(res)
        })
      }
    }
  }
</script>